import { ThunkDispatch } from "core-integration/src/store";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import {
  getJoinPrivateLeagueError,
  getJoinPrivateLeagueSuccess,
} from "core-integration/src/store/leagues/reducers";
import { joinPrivateLeague } from "core-integration/src/store/leagues/thunks";
import { IJoinPrivateLeagueData } from "core-integration/src/store/leagues/types";
import React, { useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Box } from "rebass/styled-components";
import Alert from "../Alert";
import Button from "../Button";
import Copy from "../Copy";
import { FieldWrap, InputField } from "../FieldRenderers";
import { Main, Wrapper } from "../Layout";
import Title from "../Title";
import { getErrorType } from "./errors";
import JoinLeagueError from "./JoinLeagueError";

type Props = WithTranslation;

const JoinPrivate = ({ t }: Props) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const navigate = useNavigate();
  const [code, setCode] = useState<string>("");

  const error = getErrorType(useSelector(getJoinPrivateLeagueError));
  const rules = useSelector(getRules) as IRules;
  const hasJoinedPrivate = useSelector(getJoinPrivateLeagueSuccess);

  const apiDataFromState = (): IJoinPrivateLeagueData => ({
    code,
  });

  const handleCodeChange = (e: React.SyntheticEvent<HTMLInputElement>) =>
    setCode(e.currentTarget.value);

  const handleSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(joinPrivateLeague(apiDataFromState()));
  };

  const disabled = !code;

  if (hasJoinedPrivate) {
    navigate("/leagues");
    return null;
  }

  return (
    <Wrapper>
      <Main>
        <Copy>
          <Title>{t("joinPrivate.title", "Join private league & cup")}</Title>
          {error && (
            <Box mb={2}>
              <Alert type="error">
                {rules && <JoinLeagueError error={error} rules={rules} />}
              </Alert>
            </Box>
          )}
          <form onSubmit={handleSubmit}>
            <FieldWrap>
              <InputField
                id="ismLeagueCode"
                label={t("joinPrivate.label", "League code")}
                onChange={handleCodeChange}
                value={code}
              />
            </FieldWrap>
            <FieldWrap>
              <Button type="submit" disabled={disabled}>
                {t("joinPrivate.button", "Join league")}
              </Button>
            </FieldWrap>
          </form>
        </Copy>
      </Main>
    </Wrapper>
  );
};

export default withTranslation()(JoinPrivate);
